<div class="school-brand">
  <mat-icon class="school-brand-icon" aria-hidden="true">account_balance</mat-icon>
  <div class="school-brand-text">
    <span class="school-name">{{ schoolDisplayName() }}</span>
    <span class="school-sub">School portal</span>
  </div>
</div>
<mat-divider></mat-divider>

<mat-nav-list>
    <div class="spacer">
        <b><span>APPLICATIONS</span></b>
    </div>
    <mat-divider></mat-divider>
    <a mat-list-item routerLink="/home/dashboard" routerLinkActive="list-item-active">
        <mat-icon mat-list-icon>dashboard</mat-icon>
        <span>Dashboard</span>
    </a>
    <a mat-list-item routerLink="/home/admissions" routerLinkActive="list-item-active">
        <mat-icon mat-list-icon>assignment_ind</mat-icon>
        <span>Admissions</span>
    </a>
    <a mat-list-item routerLink="/home/students" routerLinkActive="list-item-active">
        <mat-icon mat-list-icon>groups</mat-icon>
        <span>Students</span>
    </a>
    <a *ngIf="isAdmin()" mat-list-item routerLink="/home/teachers" routerLinkActive="list-item-active">
        <mat-icon mat-list-icon>supervisor_account</mat-icon>
        <span>Teachers</span>
    </a>
    <a mat-list-item routerLink="/home/attendance" routerLinkActive="list-item-active">
        <mat-icon mat-list-icon>how_to_reg</mat-icon>
        <span>Attendance</span>
    </a>
    <a *ngIf="isAdmin() || isTeacher()" mat-list-item routerLink="/home/grades" routerLinkActive="list-item-active">
        <mat-icon mat-list-icon>grading</mat-icon>
        <span>Marks & grades</span>
    </a>
    <a mat-list-item routerLink="/home/schedules" routerLinkActive="list-item-active">
        <mat-icon mat-list-icon>event_note</mat-icon>
        <span>Schedules</span>
    </a>
    <a *ngIf="isAdmin()" mat-list-item routerLink="/home/accounts" routerLinkActive="list-item-active">
        <mat-icon mat-list-icon>payments</mat-icon>
        <span>Accounts</span>
    </a>
    <a mat-list-item routerLink="/home/settings" routerLinkActive="list-item-active">
        <mat-icon mat-list-icon>settings</mat-icon>
        <span>Settings</span>
    </a>
    <mat-divider></mat-divider>
    <div class="spacer small">
        <b><span>ACCOUNT</span></b>
    </div>
    <mat-divider></mat-divider>
    <a mat-list-item routerLink="/home/profile" routerLinkActive="list-item-active">
        <mat-icon mat-list-icon>account_circle</mat-icon>
        <span>Profile</span>
    </a>
</mat-nav-list>
